import { Frown } from 'lucide-react';
import React from 'react';

import { Button } from './ui/button';

interface ErrorContainerProps {
  errorMessage?: string;
  buttonText?: string;
  buttonOnClick?: () => void;
}

export function ErrorContainer({ errorMessage, buttonText, buttonOnClick }: ErrorContainerProps) {
  return (
    <div className="w-full h-full flex flex-col justify-center">
      <Frown className="mx-auto bg-destructive/10 text-destructive p-3 rounded-full h-12 w-12 mb-4" />
      <p className="text-center text-xl font-bold mb-2">Oops! Something went wrong</p>
      <p className="text-center text-muted-foreground text-sm">
        We encountered an unexpected error. Please try again later.
      </p>

      <div className="mt-4 mx-auto">
        <p className="text-center text-muted-foreground text-xs mb-1">
          <span className="font-mono bg-muted px-2 py-1 rounded">{errorMessage}</span>
        </p>
      </div>

      {buttonText && buttonOnClick && (
        <div className="mt-6 mx-auto">
          <Button onClick={buttonOnClick}>{buttonText}</Button>
        </div>
      )}
    </div>
  );
}
